import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import HowWeWork from "./How_We_Work/How_We_Work";
import DetailedTimeline from "./DetailedTimeline/Detailed_Timeline";
import CommitmentSection from "./Commitment/Commitment";
import ReadyToStart from "../Home/Ready_To_Start/Ready_To_Start";
import GlobalCareerCTA from "../Home/GlobalCareerCTA/GlobalCareerCTA";

function Process() {
  return (
    <>
      <Common_Banner
        image="/assets/images/services_page/banner.png"
        title="Our Process"
        subtitle="8 transparent steps from application to successful placement abroad"
      />

      <HowWeWork />

      <DetailedTimeline />

      <CommitmentSection />

      {/* <ReadyToStart /> */}

      <GlobalCareerCTA />
    </>
  );
}

export default Process;
